import { render } from "./ProfileManager.vue?vue&type=template&id=2bb0f039&scoped=true"
import script from "./ProfileManager.vue?vue&type=script&lang=js"
export * from "./ProfileManager.vue?vue&type=script&lang=js"

import "./ProfileManager.vue?vue&type=style&index=0&id=2bb0f039&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb0f039"]])

export default __exports__